module.exports = __webpack_public_path__ + "static/media/aama_standing.44a8fb75.svg";